(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlideshows() {
      var heroes = document.querySelectorAll('.hero[data-slideshow]');
      heroes.forEach(function (hero) {
        if (hero.dataset.slideshowInitialized) return;
        hero.dataset.slideshowInitialized = 'true';

        var interval = parseInt(hero.dataset.slideshowInterval, 10) || 5;
        var slides = hero.querySelectorAll('.hero__media-slide');
        if (slides.length < 2) return;

        var current = Array.prototype.indexOf.call(
          slides,
          hero.querySelector('.hero__media-slide--active')
        );
        if (current === -1) current = 0;

        var timerId = setInterval(function () {
          slides[current].classList.remove('hero__media-slide--active');
          current = (current + 1) % slides.length;
          slides[current].classList.add('hero__media-slide--active');
        }, interval * 1000);

        hero._slideshowTimerId = timerId;
      });
    }

    function cleanupHeroSlideshows(e) {
      var section = e.target;
      var heroes = section.querySelectorAll('.hero[data-slideshow]');
      heroes.forEach(function (hero) {
        if (hero._slideshowTimerId) {
          clearInterval(hero._slideshowTimerId);
          delete hero._slideshowTimerId;
          delete hero.dataset.slideshowInitialized;
        }
      });
    }

    document.addEventListener('shopify:section:load', function () {
      initHeroSlideshows();
    });

    document.addEventListener('shopify:section:unload', cleanupHeroSlideshows);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroSlideshows);
    } else {
      initHeroSlideshows();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
